export const ActionTypes = {
  LOADING: "REMOVE_FROM_SHORTLIST_LOADING",
  ERROR: "REMOVE_FROM_SHORTLIST_ERROR",
  SUCCESS: "REMOVE_FROM_SHORTLIST_SUCCESS",
};
